// date-fns locale / sub-locales
export const languages = {
  cs: ['cs-CZ'],
  da: ['da-DK', 'da', 'dk'],
  de: ['de-AT', 'de-CH', 'de-DE'],
  'en-US': ['en-US', 'en-HK', 'en-SG'],
  'en-GB': ['en-GB', 'en-IE', 'en-DK', 'en-SE', 'se', 'en-HR', 'hr', 'en-SI', 'si'],
  el: ['el-GR', 'gr'],
  es: ['es-ES'],
  fr: ['fr-FR', 'fr-BE', 'fr-CH', 'fr-LU'],
  it: ['it-IT'],
  nl: ['nl-NL', 'nl'],
  pt: ['pt-PT']
};
